import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { BonusPobjednici } from '../../Layout/BonusPobjednici.jsx'

export class BonusIzazoviBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = { tabs: ['Pravila', 'Nagrade', 'Uvjeti', 'Rezultati'], selectedTab: null }

        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Bonus izazovi', 'poker', this.props.user);
    }

    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    getBody() {
        if (this.state.selectedTab == 'Pravila') {
            return <div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    <h3 className="v1">Kako osvajati bodove?</h3>
                    Bodove možete osvojiti na micro cash stolovima, a to su 0,02 €/0,04 €, 0,05 €/0,1 € i 0,1 €/0,2 €. Vaši bodovi će se multiplicirati s obzirom na kojem limitu osvajate bodove, a određeni izazovi se mogu ispuniti samo jednom dnevno, jednom tjedno ili neograničen broj puta.
                    <br /><br />
                    Sljedeća tablica prikazuje potpuno bodovanje za svaki ispunjeni izazov:
                    <br /><br />
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Bodovi</th>
                            <th className="text-left text text-6">Frekvencija</th>
                            <th className="text-left text text-6">Izazov</th>
                            <th className="text-left text text-6 text-center">Mulitplikator</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1">1</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Osvoji ili podijeli ruku sa pozicije djelitelja (dealer button)</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">2</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Vidi flop sa svoje dvije karte u ruci i još dva aktivna igrača</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">3</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Vidi flop sa svoje dvije karte u ruci dva dijeljenja za redom</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">4</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Neka vam budu podijeljene karte ranka 7 i 2</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">60</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Izgubi ruku sa AA na polaganju karata</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">250</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Vidi flop sa svoje dvije karte koji se sastoji od tri karte istog ranka</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">1000</td>
                            <td className="text text-1">Neograničeno</td>
                            <td className="text text-1">Osvojite ruku sa skalom u boji</td>
                            <td className="text text-1 text-center">DA</td>
                        </tr>
                        {/*<tr className="horizontal-lines">*/}
                        {/*    <td className="text text-1">100</td>*/}
                        {/*    <td className="text text-1">Dnevno</td>*/}
                        {/*    <td className="text text-1">Vidi po 1 flop na mobitelu i  desktopu svaki dan</td>*/}
                        {/*    <td className="text text-1 text-center">NE</td>*/}
                        {/*</tr>*/}
                        {/*<tr className="horizontal-lines">*/}
                        {/*    <td className="text text-1">100</td>*/}
                        {/*    <td className="text text-1">Tjedno</td>*/}
                        {/*    <td className="text text-1">Vidi flop 5 puta sa svoje dvije karte u ruci 3 dana za redom</td>*/}
                        {/*    <td className="text text-1 text-center">NE</td>*/}
                        {/*</tr>*/}
                        <tr className="horizontal-lines">
                            <td className="text text-1">1000</td>
                            <td className="text text-1">Tjedno</td>
                            <td className="text text-1">Vidi flop 5 puta sa svoje dvije karte u ruci 7 dana za redom</td>
                            <td className="text text-1 text-center">NE</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <div className="padding-sides-medium-2">
                    <h3 className="v1">Multiplikator</h3>
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Veličina small i big blind-a</th>
                            <th className="text-left text text-6  text-center">Multiplikator</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1">0,02 € / 0,04 €</td>
                            <td className="text text-1  text-center">1</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">0,05 € / 0,1 €</td>
                            <td className="text text-1 text-center">1.25</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1">0,1 € / 0,2 €</td>
                            <td className="text text-1 text-center">1,5</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <div className="padding-sides-medium-2">
                    Multiplikator se odnosi isključivo na izazove sa neograničenom frekvencijom.

                    <br></br>
                    <br></br>
                    <a target="_blank" style={{ color: '#1d7b60', textDecoration: 'underline' }} href={'https://cdn.supersport.hr/Casino/Poker/Pravila/PokerBonusIzazovi07_2023.pdf' + '?c=' + casino.config.guiCacheVerzija}>Pravila promocije</a>

                </div>

            </div>
        }

        if (this.state.selectedTab == 'Nagrade') {
            return (<div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    Za navedene kvalificirane stolove dijele se bonusi prema sljedećim tablicama:
                    <br /><br />
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Natjecanje</th>
                            <th className="text-right text text-6">Nagrade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1">21.08.2023. 00:00h - 27.08.2023. 23:59h</td>
                            <td className="text-right text text-7 nowrap">3.000,00 €</td>
                        </tr>

                    </tbody>
                </table>
                <div className="padding-sides-medium-2">
                    <br />
                    Isplata bonusa za igrače koji su skupili najveći broj bodova je prema sljedećoj tablici:<br />
                    200 najboljih igrača osvaja nagrade.
                    <br />     <br />
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Plasman</th>
                            <th className="text-right text text-6">Nagrada</th>
                            <th className="text-center text text-6"> &nbsp; Broj &nbsp;</th>
                            <th className="text-right text text-6">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">1.</td>
                            <td className="text-right text text-1 nowrap">500,00 €</td>
                            <td className="text text-1 text-center">1</td>
                            <td className="text-right text text-7 nowrap">500,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">2.</td>
                            <td className="text-right text text-1 nowrap">250,00 €</td>
                            <td className="text text-1 text-center">1</td>
                            <td className="text-right text text-7 nowrap">250,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">3.</td>
                            <td className="text-right text text-1 nowrap">160,00 €</td>
                            <td className="text text-1 text-center">1</td>
                            <td className="text-right text text-7 nowrap">160,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">4.-10.</td>
                            <td className="text-right text text-1 nowrap">70,00 €</td>
                            <td className="text text-1 text-center">7</td>
                            <td className="text-right text text-7 nowrap">490,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">11.-20.</td>
                            <td className="text-right text text-1 nowrap">35,00 €</td>
                            <td className="text text-1 text-center">10</td>
                            <td className="text-right text text-7 nowrap">350,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">21.-50.</td>
                            <td className="text-right text text-1 nowrap">15,00 €</td>
                            <td className="text text-1 text-center">30</td>
                            <td className="text-right text text-7 nowrap">450,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">51.-100.</td>
                            <td className="text-right text text-1 nowrap">8,00 €</td>
                            <td className="text text-1 text-center">50</td>
                            <td className="text-right text text-7 nowrap">400,00 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 ">101.-200.</td>
                            <td className="text-right text text-1 nowrap">4,00 €</td>
                            <td className="text text-1 text-center">100</td>
                            <td className="text-right text text-7 nowrap">400,00 €</td>
                        </tr>
                    </tbody>
                </table>
            </div>)
        }

        if (this.state.selectedTab == 'Uvjeti') {
            return <div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                <ul className='list'>
                    <li>Izdanje bonus izazova počinje 21. kolovoza 2023. u 00:00 sati i traje do 27. kolovoza 2023. u 23:59 sati.</li>
                    <li>Nagrade će biti isplaćene odmah po završetku natjecanja prema plasmanu igrača na tablici.</li>
                    <li>Vidjeti Flop znači da niste odustali od svoje ruke prije nego je podijeljen Flop.</li>
                    <li>Igrač mora iskoristiti barem jednu od dvije podijeljene karte da bi mogao ispuniti izazov koji uključuje skalu u boji.</li>
                    <li>Cash stolovi na micro limitima 0,02 €/0,04 €, 0,05 €/0,1 € i 0,1 €/0,2 € se kvalificiraju za osvajanje bodova</li>
                    <li>U slučaju jednakog broja bodova igračima se isplaćuje zbirna nagrada za isti plasman.</li>
                    <li>SuperSport zadržava pravo promijeniti pravila natjecanja u bilo koje vrijeme.</li>
                    <li>Primjenjuju se opća pravila SuperSporta.</li>
                </ul>
            </div>
        }

        if (this.state.selectedTab == 'Rezultati') {
            return <div>
                <h2 className="v3 padding-sides-medium-2">{this.state.selectedTab}</h2>
                <BonusPobjednici {...this.props} />
            </div>
        }
    }
    render() {
        return <div>
            <div className="segment v2 margin-top-small padding-sides-medium-2">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.getBody()}
        </div>
    }
};